import { isInside } from './util';
var CalendarDragHelper = /** @class */ (function () {
    function CalendarDragHelper(dragContainerElement, draggableElement) {
        this.dragContainerElement = dragContainerElement;
        this.startPosition = draggableElement.getBoundingClientRect();
    }
    CalendarDragHelper.prototype.validateDrag = function (_a) {
        var x = _a.x, y = _a.y;
        var newRect = Object.assign({}, this.startPosition, {
            left: this.startPosition.left + x,
            right: this.startPosition.right + x,
            top: this.startPosition.top + y,
            bottom: this.startPosition.bottom + y
        });
        return isInside(this.dragContainerElement.getBoundingClientRect(), newRect);
    };
    return CalendarDragHelper;
}());
export { CalendarDragHelper };
//# sourceMappingURL=calendar-drag-helper.provider.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/angular-calendar/modules/common/calendar-drag-helper.provider.js
// module id = ./src/app/shared/angular-calendar/modules/common/calendar-drag-helper.provider.js
// module chunks = main